<template>
    <div class="footerWrapper">
        <div class="footerContent">
            <div class="contentWrapper">
                <a target="_blank" rel="noopener" href="mailto:dmalaniouk@gmail.com">
                    <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>
                </a>
                <a target="_blank" rel="noopener" href="https://www.linkedin.com/in/dmytro-malaniouk-9367b6157/">
                    <i class="fa fa-linkedin fa-2x" aria-hidden="true"></i>
                </a>
                <a target="_blank" rel="noopener" href="https://www.instagram.com/phreak_radio/">
                    <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
                </a>
                <a target="_blank" rel="noopener" href="https://github.com/phreakradio">
                    <i class="fa fa-github fa-2x" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/_variables.scss";

    .footerWrapper{
        grid-row: 3/4;
        width: 100vw;

        display: grid;
        grid-template-columns: repeat(4, 25vw);
        max-height: 50vh;
        width: 100vw;

        .footerContent {
            grid-column: 2/4;

            .contentWrapper {
                background-color: $plainWhite;
                display: grid;
                max-width: 55%;
                margin-top: 25vh;
                margin-left:auto;
                margin-right:auto;
                min-height: 50vh;
                border: 10px solid $gumGreen;

                a {
                    margin: auto;
                }

                i:hover {
                    background: $gumGreen;
                    color: white;
                    border-color: $gumGreen;
                }

                a>i {
                    margin: 0em auto;
                    border: 1px solid black;
                    border-radius: 50%;
                    padding: 0.5em;
                    color: $darkHeroPurple;
                }
            }

        }

    }
    @media screen and (max-width: $tabletWidth){
        .footerWrapper{
            display: block;

            .footerContent{
                display: inline-flex;
                width: 100%;
                margin-bottom: 60px;

                .contentWrapper{
                    display: inline-flex;
                    min-width: 100vw;
                    min-height: 15vw;
                    margin-top:0;

                    a{
                        margin-left: auto;
                        margin-right: auto;
                    }


                }
            }
        }
    }

    @media screen and (max-width: $largeMobile){
        i{ border:none !important; }        
    }

</style>
